
import React, { useRef, useState } from 'react';
import { Input, Button } from 'antd';
import type { InputRef } from 'antd';
import { useTranslation } from 'react-i18next';

interface InlineTaskFormProps {
  statusId: string;
  onCancel: () => void;
  onSubmit: (statusId: string, title: string, description: string) => void;
}

const InlineTaskForm: React.FC<InlineTaskFormProps> = ({ statusId, onCancel, onSubmit }) => {
  const { t } = useTranslation();
  const [localTitle, setLocalTitle] = useState<string>('');
  const [localDescription, setLocalDescription] = useState<string>('');

  const descriptionRef = useRef<InputRef>(null);

  const handleSubmit = () => {
    if (!localTitle.trim()) return;

    // Pass the local values directly to onSubmit
    onSubmit(statusId, localTitle, localDescription);
  };

  return (
    <div className="inline-task-form">
      <Input
        placeholder={t('TaskTitle')}
        value={localTitle}
        onChange={(e) => setLocalTitle(e.target.value)}
        autoFocus
        className="inline-task-title hover-effect"
      />
      <Input.TextArea
        ref={descriptionRef}
        placeholder={t('Description')}
        value={localDescription}
        onChange={(e) => setLocalDescription(e.target.value)}
        autoSize={{ minRows: 2, maxRows: 4 }}
        className="inline-task-description hover-effect"
      />
      <div className="inline-task-actions">
        <Button
          type="primary"
          onClick={handleSubmit}
          disabled={!localTitle.trim()}
          className="hover-effect"
        >
          {t('Add')}
        </Button>
        <Button onClick={onCancel} className="hover-effect">
          {t('Cancel')}
        </Button>
      </div>
    </div>
  );
};

export default InlineTaskForm;